import React, { createContext, PropsWithChildren, useContext, useState } from "react";
import type { ConversationTurnRouting } from "../types";

type SearchRoutingContextType = {
  routing: ConversationTurnRouting | undefined;
  setRouting: (routing: ConversationTurnRouting | undefined) => void;
};

export const SearchRoutingContext = createContext<SearchRoutingContextType | undefined>(undefined);

export function SearchRoutingProvider({ children }: PropsWithChildren) {
  const [routing, setRouting] = useState<ConversationTurnRouting | undefined>(undefined);

  return (
    <SearchRoutingContext.Provider
      value={{
        routing,
        setRouting,
      }}
    >
      {children}
    </SearchRoutingContext.Provider>
  );
}

export function useSearchRouting() {
  const context = useContext(SearchRoutingContext);
  if (context === undefined) {
    throw new Error("useSearchRouting cannot be used outside of a SearchRoutingProvider");
  }

  return context;
}
